import React, { Component } from 'react';
export default class ContactUs extends Component {
  render() {
    let resumeData = this.props.resumeData;
    return (
      <section id="contact">
        <div className="row ">
          <div className="ten columns">
            <p className="lead" style={{color:"white"}}>
              Feel free to contact me for any work or suggestions on below
              </p>
          </div>
        </div>
        <div className="row">
          <aside className="eigth columns footer-widgets">
            <div className="widget">
              <h4>LinkedIn : 
                 {" "+resumeData.linkedinId}
              </h4>
              <h4>Email :
                  pujanshah22@gmail.com
              </h4>
              <h4>Phone No :
                  +91-7383350424
              </h4>
            </div>
          </aside>
        </div>
      </section>
    );
  }
}